export const FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_REQUEST = 'FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_REQUEST';
export const FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_SUCCESS = 'FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_SUCCESS';
export const FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_FAILURE = 'FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_FAILURE';

export const FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_REQUEST = 'FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_REQUEST';
export const FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_SUCCESS = 'FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_SUCCESS';
export const FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_FAILURE = 'FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_FAILURE';
